<template>
  <div class="logOffScuess_box">
    <div class="success_icon">
      <img src="../../assets/images/achieved.png"
           alt="">
      <p>{{successTitle}}</p>
    </div>
    <li class="form_item form_submit"
        @click="getNextStep"
        ref='form_submit'>
      {{$t('successText.goBack')}}
    </li>
  </div>
</template>

<script>
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      successTitle: '',
      id: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.id = parseInt(this.$route.query.id)
      let successTitle
      switch (this.id) {
        case 1:
          successTitle = this.$t('successText.successTitle1')
          break
        case 2:
          successTitle = this.$t('successText.successTitle2')
          break
        case 3:
          successTitle = this.$t('successText.successTitle3')
          break
        case 4:
          successTitle = this.$t('successText.successTitle4')
          break
        case 5:
          successTitle = this.$t('successText.successTitle4')
          break
        case 6:
          successTitle = this.$t('successText.successTitle4')
          break
        case 7:
          successTitle = this.$t('successText.successTitle1')
          break
      }
      this.successTitle = successTitle
    },
    getNextStep() {
      const homePage = getSessionStorage('homePage')
      if (this.id == 7) {
        this.$router.push('/')
      } else {
        this.$router.push(homePage)
      }
    },
  },
}
</script>

<style scoped lang='less'>
.logOffScuess_box {
  padding: 30/75rem;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .success_icon {
    width: 300/75rem;
    margin: 0 auto;
    margin-top: 100/75rem;
    text-align: center;
    font-size: 30/75rem;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #646464;
    img {
      width: 120/75rem;
      height: auto;
      margin: 0 auto;
      margin-bottom: 25/75rem;
    }
  }
  .logOffScuess_title {
    font-size: 28/75rem;
    font-weight: 700;
  }
  .form_submit {
    width: 610/75rem;
    height: 76/75rem;
    background: #ff7391;
    opacity: 1;
    border-radius: 6/75rem;
    font-family: 'Microsoft YaHei';
    font-size: 30/75rem;
    color: #fff;
    line-height: 76/75rem;
    letter-spacing: 10/75rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 60/75rem;
  }
}
</style>